import React, { useState } from 'react';
import { Colors as C } from '../../constants/Colors.js';
import { prepareInstagramCarousel } from '../../lib/instagramCarouselService.js';

const btnBar = {
  padding: '8px 14px',
  borderRadius: 8,
  border: '0.5px solid rgba(200,168,75,0.45)',
  background: 'rgba(200,168,75,0.12)',
  color: C.gold,
  fontSize: 12,
  fontWeight: 700,
  cursor: 'pointer',
};

/**
 * Barra flotante: envía selección a n8n → Telegram (workflow «Envío carrusel»).
 * @param {{ tipo: 'noticias' | 'eventos', selection: ReturnType<import('../hooks/useAdminCarouselSelection.js').useAdminCarouselSelection>, onError?: (msg: string) => void, onSuccess?: (msg: string) => void }} props
 */
export default function AdminInstagramCarouselBar({ tipo, selection, onError, onSuccess }) {
  const [busy, setBusy] = useState(false);

  if (!selection.enabled) return null;

  const handlePrepare = async () => {
    if (busy || selection.count < 1) return;
    const n = selection.count;
    if (
      !window.confirm(
        `¿Enviar ${n} ${tipo === 'noticias' ? 'noticia' : 'evento'}${n === 1 ? '' : 's'} a Telegram vía n8n (carrusel)?`,
      )
    ) {
      return;
    }
    setBusy(true);
    onError?.('');
    try {
      const res = await prepareInstagramCarousel({ tipo, ids: selection.ids });
      if (!res.ok) {
        onError?.(res.error || 'No se pudo preparar el carrusel.');
        return;
      }
      selection.clear();
      onSuccess?.(
        `${res.count ?? n} slide${(res.count ?? n) === 1 ? '' : 's'} enviadas a Telegram vía n8n. Revisa el canal para descargar las imágenes.`,
      );
    } catch (e) {
      onError?.(e?.message || 'Error al enviar a n8n.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 10,
        marginBottom: 12,
        padding: '10px 14px',
        borderRadius: 10,
        background: 'rgba(200,168,75,0.08)',
        border: '1px solid rgba(200,168,75,0.28)',
      }}
    >
      <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.75)' }}>
        <strong style={{ color: C.gold }}>{selection.count}</strong>
        {selection.max ? ` / ${selection.max}` : ''} seleccionada{selection.count === 1 ? '' : 's'}
      </span>
      <button
        type="button"
        style={{ ...btnBar, opacity: selection.count < 1 ? 0.45 : 1 }}
        disabled={busy || selection.count < 1}
        onClick={handlePrepare}
      >
        {busy ? 'Enviando…' : 'Enviar carrusel a Telegram'}
      </button>
      {selection.count > 0 ? (
        <button
          type="button"
          disabled={busy}
          onClick={() => selection.clear()}
          style={{
            ...btnBar,
            borderColor: 'rgba(255,255,255,0.15)',
            background: 'transparent',
            color: 'rgba(255,255,255,0.55)',
            fontWeight: 600,
          }}
        >
          Limpiar
        </button>
      ) : null}
      <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)', flex: '1 1 200px' }}>
        Workflow n8n «Envío carrusel»: compone imagen+texto por publicación y las envía a Telegram.
      </span>
    </div>
  );
}
